// extracted by mini-css-extract-plugin
export default {"draggableOne":"CommenText_draggableOne__fEPq6","draggableTwo":"CommenText_draggableTwo__JRTfI"};